<template>
  <div class="row align-items-center">
    <div class="col">
      <p v-if="!mine">
        <span class="dash-ope__type user-dash__badge badge font-size-normal mb-1 mr-2" :class="'badge-outline-' + $mainColor">
          {{ training.seats }}
        </span>
      </p>
      <p>
        <span class="dash-ope__id user-dash__badge badge" :class="statusBadge" v-if="mine">
          {{ training.formatted_status }}
        </span>
      </p>
      <h5>{{ training.name }}</h5>
      <p class="mb-0" :class="'text-' + $mainColor">
         Le {{ training.formatted_start_at.toLowerCase() }}
      </p>
    </div>
    <div class="col-auto ml-auto">
      <button
        v-if="mine && convocable"
        type="button"
        :class="'btn-outline-' + $mainColor"
        class="btn thin mr-2">
        Imprimer ma convocation
      </button>
      <button
        v-if="!mine"
        type="button"
        :class="'btn-outline-' + $mainColor"
        class="btn thin mr-2"
        @click.prevent="registration">
        Je m'inscris
      </button>
      <button
        type="button"
        class="btn thin collapsed"
        :class="'btn-' + $mainColor"
        data-toggle="collapse"
        :data-target="'#ope2Details' + training.id"
        aria-expanded="false"
        :aria-controls="'ope2Details' + training.id">
        Détails
        <i class="bestove-icon__arrow-top ml-h"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InterventionHeader',
  props: {
    training: {
      type: Object,
      default: () => {}
    },
    mine: Boolean
  },
  computed: {
    ...mapState(['currentUser', 'userAuth']),
    statusBadge () {
      if (this.training.formatted_status === 'Terminée') {
        return 'badge-success'
      } else if (this.training.formatted_status === 'Validée') {
        return 'badge-outline-success'
      } else {
        return 'badge-warning'
      }
    },
    convocable () {
      // TODO - create PDF
      // return this.training.formatted_status === 'Validée'
      return false
    }
  },
  methods: {
    registration () {
      if (confirm(`Valider l'inscription à la formation ${this.training.name} ?`)) {
        this.$http.put('/user_auth', {
          training_session_id: this.training.id
        }, {
          headers: this.userAuth
        }).then(resp => {
          this.$store.dispatch('fetchTrainings')
        })
      }
    }
  }
}
</script>
